<template>
  <div id="contact">
    <CommonHeader></CommonHeader>
    <div class="banner">
      <img src="/images/banner2.png" />
    </div>
    <div class="main8 wrap">
      <div class="main8-left">
        <div class="main8-left-title">
          <span v-for="(item, index) in main8.header" :key="index" :class="'main8-title'+index" v-text="item.title"></span>
        </div>
      </div>
      <div class="main8-right">
        <div class="main8-right-title">
          当前位置：<a href="/">首页</a> <span>&gt;</span> <strong v-text="contact"></strong>
        </div>
        <div class="main8-right-content">
          <h4 v-text="contact"></h4>
          <div class="clearfix">
            <mapDrag class="mapbox" lat="31.248006" lng="121.451381"></mapDrag>
            <div class="main8-right-content-right">
              <div class="company" v-text="company"></div>
              <div class="phone" v-text="phoneNumber"></div>
              <div class="address" v-text="address"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
import CommonFooter from "@/components/CommonFooter.vue"
import mapDrag from '@/components/mapDrag'

export default {
  name: "contact",
  components: {
    CommonHeader,
    CommonFooter,
    mapDrag
  },

  data() {
    return {
      main8: {
        header: [],
        body: [],
      },
      contact: '',
      phoneNumber: '',
      address: '',
      company: '',
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.$http
        .get("/data/contact.json")
        .then(response => {
          if (response.data) {
            this.main8.header = response.data.main8.header;
            this.contact = response.data.main8.contact;
            this.phoneNumber = response.data.main8.phoneNumber;
            this.address = response.data.main8.address;
            this.company = response.data.main8.company;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less">
.main8 {
  margin: 50px auto;
  min-height: 500px;

  .active {
    display: inline-block;
  }

  .main8-left {
    float: left;
    width: 180px;

    .main8-left-title {
      span {
        display: block;
        width: 180px;
        height: 79px;
        font-weight: bold;
        text-align: center;
        letter-spacing: 1px;
        color: #fff;
        background: #5cadff;
      }

      .main8-title0 {
        padding-top: 45px;
        font-size: 24px;
      }

      .main8-title1 {
        font-size: 20px;
      }
    }
  }

  .main8-right {
    float: left;
    width: 900px;
    margin-left: 49px;

    .main8-right-title {
      padding: 10px 0 25px;
      border-bottom: solid 2px #5cadff;
      color: #999;
      cursor: pointer;

      a {
        color: #999;
      }

      span {
        padding: 0 10px;
      }
    }

    .main8-right-content {
      h4 {
        padding: 28px 0 47px;
        font-weight: bold;
        font-size: 24px;
        color: #333;
      }
    }

    .main8-right-content-right {
      float: left;
      width: 350px;
      padding-top: 80px;
      margin-left: 45px;
      color: #333;

      .company {
        font-size: 24px;
      }

      .phone {
        line-height: 3.5;
        font-size: 18px;
      }

      .address {
        font-size: 18px;
      }
    }
  }
}

.mapbox {
  float: left;
  width: 500px;
  height: 300px;
}
</style>
